module.exports = "/lucky-balls/img/bigball/BigBall_025.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_025.png
// module id = 920
// module chunks = 0